import { globalThemeParams } from "@/api";
import {complete} from '@/utils/url'

import {Toast} from "vant";
/**
 * 判断当前处于哪个平台
 * @type {{dingtalk: boolean, app: boolean, wxwork: boolean, android: boolean, wechat: boolean, ios: boolean, zhuoyun: *}}
 */
export const env = (() => {
  const ua = window.navigator.userAgent;
  console.log("ua:",ua)
  return {
    /*IOS*/
    ios: /(iphone|ipad|ipod)/i.test(ua),
    /*Android*/
    android: /android/i.test(ua),
    /*微信*/
    wechat: /micromessenger/i.test(ua),
    /*企业微信*/
    wxwork: /wxwork/i.test(ua),
    /*微信小程序*/
    miniProgram: /miniProgram/i.test(ua),
    /*钉钉*/
    dingtalk: /dingtalk/i.test(ua),
    /*华为*/
    welink: /huawei(.*)anyoffice/i.test(ua.toLocaleLowerCase()),
    /*华腾APP*/
    app: /huatechapp/i.test(ua),
    /*卓云APP*/
    zhuoyun: window.nativePageListener && window.nativePageListener.getUserInfo && window.nativePageListener.openFile,
    /*西安交大APP（北京思源）*/
    toon: /toongine/i.test(ua),
  }
})();

/**
 * 初始化js调试
 */
export const initDebug = () => {
  if (/eruda=false/.test(window.location)) {
    localStorage.setItem('eruda', 'false')
  } else if (/eruda=true/.test(window.location) || localStorage.getItem('eruda') == 'true') {
    try {
      let script = document.createElement('script')
      script.src = "//cdn.jsdelivr.net/npm/eruda"
      document.body.appendChild(script)
      script.onload = () => eruda.init()
      localStorage.setItem('eruda', 'true')
    } catch (e) {
      console.log(e)
    }
  }
}

/**
 * 获取指定用户头像链接
 * @param UUID
 * @returns {string}
 */
export const getAvatarByUUID = UUID => complete(`user/photo.htm?uuid=${UUID}`)

//滚动位置前缀
const scrollPositionSessionPrefix = 'scroll-position-of-'
/**
 * 管理页面滚动位置
 * @param pageName
 * @param scrollEl
 */
export const scrollBehavior = (pageName, scrollEl) => {
  const key = scrollPositionSessionPrefix + pageName
  // 恢复位置
  resumeScrollTop(pageName, scrollEl)

  // 监听滚动
  scrollEl.addEventListener('scroll', event => {
    sessionStorage.setItem(key, scrollEl.scrollTop)
  }, {passive: true})
}

/**
 * 恢复滚动高度
 * @param pageName
 * @param scrollEl
 */
export const resumeScrollTop = (pageName, scrollEl) => {
  const key = scrollPositionSessionPrefix + pageName
  const scrollTop = parseInt(sessionStorage.getItem(key))
  if (scrollTop) {
    const timer = setInterval(() => {
      if (scrollEl.scrollHeight >= scrollTop + scrollEl.clientHeight - 20) {
        clearInterval(timer)
        scrollEl.scrollTop = scrollTop
      }
    }, 100)
  }
}

/**
 * 重置滚动高度
 * @param pageName
 * @param scrollEl
 */
export const resetScrollTop = (pageName, scrollEl) => {
  sessionStorage.removeItem(scrollPositionSessionPrefix + pageName)
  scrollEl.scrollTop = 0
}

/**
 * 十六进制颜色转RGB
 * @param hexColor 十六进制颜色
 */
export const fetchRgbColer = (hexColor)=>{
  if(!hexColor) {
    return ''
  }
  var color = hexColor.toLowerCase();
  //十六进制颜色值的正则表达式
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  // 如果是16进制颜色
  if (color && reg.test(color)) {
    // 如果只有三位的值，需变成六位，如：#fff => #ffffff
    if (color.length === 4) {
      var colorNew = "#";
      for (let i = 1; i < 4; i += 1) {
        colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
      }
      color = colorNew;
    }
    // 处理六位的颜色值，转为RGB
    var colorChange = [];
    for (let i = 1; i < 7; i += 2) {
      colorChange.push(parseInt("0x" + color.slice(i, i + 2)));
    }
    return colorChange;
  }
  return color;
}